import { AxDatePicker, Cell, Mode, Options } from "../../Components/AxDatepicker/AxDatepicker";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AxCounter } from '../../Limestone/AxCounter/AxCounter';
import { AxDropdown } from "@axess/limestone"
import { Subject } from "rxjs";

export class LessonFilter {
    datePickers: AxDatePicker[];
    initData: ILessonFilterInitData;

    levelDropdown: AxDropdown;
    pTypeDropdown: AxDropdown;
    dateDropdown: AxDropdown;

    currentSearch: SearchDto;
    currentSearchDate: moment.Moment;

    searchSubjection: Subject<SearchDto>;
    searchUpdateSubject: Subject<SearchDto>;

    counterArr: AxCounter[];

    init(initData: ILessonFilterInitData) {
        this.counterArr = [];
        this.searchSubjection = new Subject<SearchDto>();
        this.searchUpdateSubject = new Subject<SearchDto>();
        this.initData = initData;
        this.initLibs();
        this.initEventHandler();
    }

    updateDate(date: string) {
        let dateM = moment(date, 'YYYY-MM-DD');

        for (let picker of this.datePickers) {
            picker.setDate(dateM);
        }
    }

    setDefaults(searchDto: SearchDto) {
        if (searchDto.date != null && searchDto.date != '') {
            for (let picker of this.datePickers) {
                picker.setDate(moment(searchDto.date, 'YYYY-MM-DD'));
            }
        }

        if (searchDto.levels != null && searchDto.levels.length > 0) {
            for (const level of searchDto.levels) {
                $(`input[name="lessonPackage_filter_level-input"][value="${level}"]`).prop('checked', true);
            }
        }

        if (searchDto.locations != null && searchDto.locations.length > 0) {
            for (const location of searchDto.locations) {
                $(`input[name="lessonPackage_filter_location-input"][value="${location}"]`).prop('checked', true);
            }
        }

        if (searchDto.quantity != null && searchDto.quantity.length > 0) {
            for (const quantity of searchDto.quantity.filter(x => x.quantity > 0)) {
                this.counterArr[quantity.id].setValue(quantity.quantity);
            }
        }

        this.currentSearch = searchDto;
    }

    getSearchUpdateSubject() {
        return this.searchUpdateSubject;
    }

    getSearchSubject() {
        return this.searchSubjection;
    }

    initLibs() {
        this.datePickers = [];

        //Datepicker has to be invoked before dropdowns since tippy removes them from DOM
        const datePickerOptions: Options = {
            StartOfWeek: this.initData.startOfWeek,
            Lang: this.initData.lang,
            StartDate: moment(),
            DayRange: 0,
            Target: '#tariff_date_mobile',
            Mode: Mode.Endless,
            LegendTarget: '#tariff_date_mobile__legend',
            scrollTargetQuerySelector: '[data-lp-landing="datepicker"]'
        };
        let tmp = new AxDatePicker();
        tmp.Init(datePickerOptions);
        this.datePickers.push(tmp);

        for (let elem of $(`[data-display-lp="datepicker"]`)) {
            let tmp2 = new AxDatePicker();
            tmp2.Init({
                StartOfWeek: this.initData.startOfWeek,
                Lang: this.initData.lang,
                StartDate: moment(),
                DayRange: 0,
                Target: elem,
                Mode: Mode.Inline,
                EndDate: null,
                monthsShown: 1
            });
            this.datePickers.push(tmp2);
        }


        this.levelDropdown = new AxDropdown();
        this.levelDropdown.init('.lessonPackage_filter_level-drpdn');

        this.pTypeDropdown = new AxDropdown();
        this.pTypeDropdown.init('.lessonPackage_filter_pType-drpdn');

        this.dateDropdown = new AxDropdown();
        this.dateDropdown.init('.lessonPackage_filter_date-drpdn');


        for (let pType of this.initData.pTypes) {
            const tmpCounter = new AxCounter();
            tmpCounter.Init({
                Selector: `.filter__counter_${pType.id}`,
                Value: pType.quantity
            });

            tmpCounter.Subscribe(n => {
                pType.quantity = n;
                this.updatePTypeText();
                this.saveSearchValues();
            });

            this.counterArr[pType.id] = tmpCounter;
        }
        this.updatePTypeText();
        this.saveSearchValues();
    }

    initEventHandler() {
        for (let picker of this.datePickers) {
            picker.ActivationSubject.subscribe((cell: Cell) => {
                if (cell != null) {
                    this.setDate(cell);

                    if ($(picker.parentElement).is('[data-display-lp-calendar-nav="trigger"]')) {
                        this.triggerSearch();
                    }
                }
            });
        }
        $('.lessonPackage_filter-search').on('click',
            () => {
                this.triggerSearch();
            });

        $('input[name=lessonPackage_filter_location-input]').on('change',
            (e) => {
                let $target = $(e.delegateTarget);
                $(`input[name=lessonPackage_filter_location-input][value=${$target.val()}]`).prop('checked', $target.prop('checked'));

                this.saveSearchValues();
            });

        $('input[name=lessonPackage_filter_level-input]').on('change',
            () => {
                this.updateLessonLevelText();
                this.saveSearchValues();
            });
    }

    triggerSearch() {
        if (this.currentSearch?.date != null) {
            const currentMom = moment(this.currentSearch.date, 'YYYY-MM-DD');

            if (currentMom.isValid()) {
                for (let p of this.datePickers) {
                    p.setDate(currentMom, false);
                }
                let monthDisplay = $('[data-display-lp-calendar-nav="month"]');

                if (monthDisplay.length > 0) {
                    this.dateDropdown.setValue(currentMom.format(`MMMM YYYY`), monthDisplay);
                }
            }
        }
        this.searchSubjection.next(this.currentSearch);
    }

    saveSearchValues() {
        const searchData = new SearchDto();

        searchData.levels = [];
        for (let checkbox of $('input[name=lessonPackage_filter_level-input]:checked')) {
            searchData.levels.push(parseInt($(checkbox).val() as string));
        }

        searchData.locations = [];
        for (let checkbox of $('input[name=lessonPackage_filter_location-input]:checked')) {
            searchData.locations.push(parseInt($(checkbox).val() as string));
        }

        searchData.quantity = [];
        for (let pType of this.initData.pTypes) {
            searchData.quantity.push({
                id: pType.id,
                quantity: pType.quantity
            });
        }

        const currentDateValue = this.currentSearchDate;

        if (currentDateValue != null) {
            searchData.date = this.currentSearchDate.format("YYYY-MM-DD");
        }

        this.currentSearch = searchData;
        this.searchUpdateSubject.next(this.currentSearch);
    }

    setDate(cell: Cell) {
        if (cell != null) {
            this.dateDropdown.setValue(cell.Date.format(this.initData.datePattern));
            this.dateDropdown.close();
            this.currentSearchDate = cell.Date;
            this.saveSearchValues();
        }
    }

    updateLessonLevelText() {
        if ($('.lessonPackage_filter_level-drpdn').length === 0) return;

        let selectedLevelNames = [];
        $('input[name=lessonPackage_filter_level-input]:checked').each((i, e) => {
            selectedLevelNames.push($(e).parent().find('.lessonPackage_filter_level-name span').text());
        });

        if (selectedLevelNames.length > 0) {
            this.levelDropdown.setValue(selectedLevelNames.join(' • '));
        } else {
            this.levelDropdown.resetSelection();
        }
    }

    updatePTypeText() {
        if ($('.lessonPackage_filter_pType-drpdn').length === 0) return;

        let text: string[] = [];
        for (let pType of this.initData.pTypes) {
            if (pType.quantity === 0 || pType.quantity == null) continue;

            text.push(`${pType.quantity}x ${this.decodeHtml(pType.name)}`);
        }

        if (text.length > 0) {
            this.pTypeDropdown.setValue(text.join(' • '));
        } else {
            this.pTypeDropdown.resetSelection();
        }
    }

    decodeHtml(html: string) {
        let txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }
}
export interface ILessonFilterInitData {
    startOfWeek: number;
    lang: string;
    datePattern: string;
    pTypes: IPersonTypeList[];
    targetUrl: string;
}

export interface IPersonTypeList {
    id: number;
    name: string;
    quantity: number;
}

export class SearchDto {
    quantity?: { id: number; quantity: number; }[];
    levels?: number[];
    locations?: number[];
    date?: string;
}